WL.registerComponent('wrapper', {
    unwrapped: {type: WL.Type.Object},
    wrapped: {type: WL.Type.Object},
    wrappedWithRibbon: {type: WL.Type.Object},
}, {
    start(){
        this.paperMaterial = null;
        this.ribbonMaterial = null;
        this.hasRibbon = false;
        this.hasPaper = false;
        this.paperSubtype = null;
        this.ribbonSubtype = null;
    },
    wrap(material, subtype) {         
        if(this.hasPaper) return;       
        this.hasPaper = true;
        this.unwrapped.getComponent('mesh').active = false;        
     
        this.oldWrappedParent = this.wrapped.parent;
        this.wrapped.parent = this.object;
        const wr = this.wrapped.getComponent('mesh');
        wr.material = material;
        wr.active = true;
        this.paperMaterial = material;
        this.paperSubtype = subtype;
    },
    getTypes(){
        const gift = {
            gift: this.unwrapped.name,
            paper: this.paperSubtype,
            ribbon: this.ribbonSubtype
        };
        return gift;
    },
    wrapRibbon(material, subtype) {
        if(!this.hasPaper) return;
        if(this.hasRibbon) return;       
        this.hasRibbon = true;
        this.oldRibbonParent = this.wrappedWithRibbon.parent;
       
        this.wrapped.parent = this.oldWrappedParent;        
        const wr = this.wrapped.getComponent('mesh');
        wr.active = false;        
       
        this.wrappedWithRibbon.parent = this.object;
        const m1 = this.wrappedWithRibbon.getComponent('mesh', 0);
        m1.material = this.paperMaterial;    
        m1.active = true;    
        const m2 = this.wrappedWithRibbon.getComponent('mesh', 1);
        m2.material = material;   
        m2.active = true;
       
        this.ribbonMaterial = material;
        this.ribbonSubtype = subtype;
    },

    reset(){
        this.unwrapped.getComponent('mesh').active = true;
        this.wrapped.parent = this.oldWrappedParent;
        this.wrappedWithRibbon.parent = this.oldRibbonParent;
        this.wrapped.getComponent('mesh').active = false;
        this.wrappedWithRibbon.getComponent('mesh',0).active = false;
        this.wrappedWithRibbon.getComponent('mesh',1).active = false;
        this.paperMaterial = null;
        this.ribbonMaterial = null;
        this.hasRibbon = false;
        this.hasPaper = false;
        this.paperSubtype = null;
        this.ribbonSubtype = null;
    }    
});
